import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  permissions: [],
  hasMarketplace: false
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setPermissions: (state, action) => {
      state.permissions = [...action.payload]
    },
    setHasMarketplace: (state, action) => {
      state.hasMarketplace = action.payload
    }
  },
});

// Action creators are generated for each case reducer function
export const { setPermissions, setHasMarketplace } = appSlice.actions;

export const selectPermissions = (state) => state?.app?.permissions;
export const selectHasMarketplace = (state) => !!state?.app?.hasMarketplace;

export default appSlice.reducer;
